"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DoneIcon = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("@emotion/react");
const DoneIcon = (_a) => {
    var { color } = _a, props = __rest(_a, ["color"]);
    const theme = (0, react_1.useTheme)();
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none" }, props, { children: (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.27924 11.1906C4.84457 10.8054 4.18284 10.8338 3.78274 11.2548C3.36566 11.6937 3.39173 12.3899 3.84046 12.7964L9.82082 18.2137C10.261 18.6124 10.9495 18.5419 11.2998 18.0623L19.6146 6.67637C19.9454 6.22342 19.8398 5.58714 19.3804 5.26536C18.9348 4.95323 18.3215 5.05391 17.9991 5.49212L10.4405 15.7649L5.27924 11.1906Z", fill: color !== null && color !== void 0 ? color : theme.colors.grey90 }) })));
};
exports.DoneIcon = DoneIcon;
//# sourceMappingURL=done_icon.js.map